export default __webpack_public_path__ + "static/media/regulatory--no-pedestrians--g1.654534fc.png";